const iframeResize = require('./js/iframeResizer')

module.exports = {
  iframeResize: iframeResize,
  iframeResizer: iframeResize, // Backwards compatibility
  contentWindow: require('./js/iframeResizer.contentWindow')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/iframe-resizer/index.js
// module id = 1999
// module chunks = 1